import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "../api/ApiClient";

export interface SubscriberGrowthPoint {
  month: string;
  total_subscribers: number;
}

export function useSubscriberGrowth() {
  const { getToken } = useAuth();
  const api = createApiClient(getToken);

  return useQuery({
    queryKey: ["dashboard-charts-subscriber-growth"],
    queryFn: () => api.get<SubscriberGrowthPoint[]>("/vendors/dashboard/charts/subscriber-growth"),
  });
}
